<template>
  <div class="ant-card ant-card-bordered ant-card-hoverable ant-card-contain-grid">
    <div class="ant-card-head"
         @click="$router.replace({path: '/browse/datasets'})">
      <div class="ant-card-head-wrapper">
        <div class="ant-card-head-title">
          <strong style="color: rgb(54, 54, 54); font-size: 1.1em;">
            Computationally Putative Splicing Events (CPSE)
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Computationally putative splicing events by data mining</span>
            </v-tooltip>
          </strong>
        </div>
      </div>
    </div>
    <div class="ant-card-body">
      <div class="ant-card-grid ant-card-grid-hoverable"
           style="width: 50%; text-align: center;"
           @click="goToDatasets('TCGA')">
        <div class="ant-statistic">
          <div class="ant-statistic-title"><strong style="color: rgb(54, 54, 54); font-size: 1.2em;">TCGA</strong></div>
          <div class="ant-statistic-content"
               style="color: rgb(63, 134, 0);">
            <span class="ant-statistic-content-prefix">
              <span role="img"
                    class="anticon">
              </span>
            </span>
            <span class="ant-statistic-content-value">
              <span class="ant-statistic-content-value-int info--text"
                    style="color: rgb(54, 54, 54);">{{tcga_cpase}}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="ant-card-grid ant-card-grid-hoverable"
           style="width: 50%; text-align: center;"
           @click="goToDatasets('GTEx')">
        <div class="ant-statistic">
          <div class="ant-statistic-title"><strong style="color: rgb(54, 54, 54); font-size: 1.2em;">GTEx</strong></div>
          <div class="ant-statistic-content"
               style="color: rgb(63, 134, 0);">
            <span class="ant-statistic-content-prefix"><span role="img"
                    class="anticon">

              </span></span>
            <span class="ant-statistic-content-value"><span class="ant-statistic-content-value-int info--text"
                    style="color: rgb(54, 54, 54);">
                {{gtex_cpase}}</span></span>
          </div>
        </div>
      </div>
      <!-- <div class="ant-card-grid ant-card-grid-hoverable"
           style="width: 33.33333%; text-align: center;"
           @click="goToDatasets('GEO')">
        <div class="ant-statistic">
          <div class="ant-statistic-title">
            <strong style="color: rgb(54, 54, 54); font-size: 1.2em;">GEO</strong>
          </div>
          <div class="ant-statistic-content"
               style="color: rgb(63, 134, 0);"><span class="ant-statistic-content-prefix"><span role="img"
                    class="anticon">

              </span>
            </span><span class="ant-statistic-content-value">
              <span class="ant-statistic-content-value-int info--text"
                    style="color: rgb(54, 54, 54);">
                {{geo_cpase}}</span></span></div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>

export default {
  name: 'test',
  data() {
    return {
      tcga_cpase: "1,111,805",
      gtex_cpase: "867,164",
      geo_cpase: "581,256 ",
    }
  },
  mounted() {
  },
  methods: {
    // 注意：此处不能用 replace，否则返回不到上一页
    goToDatasets(source) {
      this.$router.push({
        path: '/browse/datasets',
        query: {
          source: source,
          page: 1,
          size: 15,
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    }
  },
}
</script>
<style scoped>
@import url('../../sass/ant-statistics.css');

@media only screen and (max-width: 767px) {
  .ant-statistic-content-value-int {
    font-size: 0.8em;
  }
  .ant-card-grid {
    height: 150px;
  }
}
</style>